"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNursysTransactionDto = instanceOfNursysTransactionDto;
exports.NursysTransactionDtoFromJSON = NursysTransactionDtoFromJSON;
exports.NursysTransactionDtoFromJSONTyped = NursysTransactionDtoFromJSONTyped;
exports.NursysTransactionDtoToJSON = NursysTransactionDtoToJSON;
exports.NursysTransactionDtoToJSONTyped = NursysTransactionDtoToJSONTyped;
const NursysTransactionType_1 = require("./NursysTransactionType");
const NursysTransactionStatus_1 = require("./NursysTransactionStatus");
const NursysTransactionLicenseDto_1 = require("./NursysTransactionLicenseDto");
/**
 * Check if a given object implements the NursysTransactionDto interface.
 */
function instanceOfNursysTransactionDto(value) {
    if (!('transactionId' in value) || value['transactionId'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('statusMessage' in value) || value['statusMessage'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('processedAt' in value) || value['processedAt'] === undefined)
        return false;
    if (!('licenses' in value) || value['licenses'] === undefined)
        return false;
    return true;
}
function NursysTransactionDtoFromJSON(json) {
    return NursysTransactionDtoFromJSONTyped(json, false);
}
function NursysTransactionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'transactionId': json['transactionId'],
        'type': (0, NursysTransactionType_1.NursysTransactionTypeFromJSON)(json['type']),
        'status': (0, NursysTransactionStatus_1.NursysTransactionStatusFromJSON)(json['status']),
        'statusMessage': json['statusMessage'],
        'createdAt': (new Date(json['createdAt'])),
        'processedAt': (json['processedAt'] == null ? null : new Date(json['processedAt'])),
        'licenses': (json['licenses'].map(NursysTransactionLicenseDto_1.NursysTransactionLicenseDtoFromJSON)),
    };
}
function NursysTransactionDtoToJSON(json) {
    return NursysTransactionDtoToJSONTyped(json, false);
}
function NursysTransactionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'transactionId': value['transactionId'],
        'type': (0, NursysTransactionType_1.NursysTransactionTypeToJSON)(value['type']),
        'status': (0, NursysTransactionStatus_1.NursysTransactionStatusToJSON)(value['status']),
        'statusMessage': value['statusMessage'],
        'createdAt': ((value['createdAt']).toISOString()),
        'processedAt': (value['processedAt'] == null ? null : value['processedAt'].toISOString()),
        'licenses': (value['licenses'].map(NursysTransactionLicenseDto_1.NursysTransactionLicenseDtoToJSON)),
    };
}
//# sourceMappingURL=NursysTransactionDto.js.map